module.exports = __webpack_public_path__ + "img/book-lighter.f9341b58.svg";